
<div class="container" *ngIf="!loadIndicator; else loading">
  <ng-container *ngIf="participants != 0; else nodata">

  <div class="tab-content team">
    <div class="team-container"
         *ngFor="let participant of participants;index as index"
         id="{{participant?.participant_id}}"
         [ngClass]="{'incomplete': participant?.incomplete}">
      <div class="flex_block">
        <img [src]="participant?.avatar" alt="team_image"/>
        <div class="info">
          <h1>{{participant?.participant_name|truncate :participant.truncate}}</h1>
          <div class="flex_block">
            <div class="item">
              <div class="flag_container_rounded">
                <img
                  src="assets/img/flags/{{globalService.getCountryAbbr(participant?.country)}}.svg"
                  alt="{{participant?.country}}">
              </div>

              <p style="margin: 3px">{{participant?.country}}</p>
            </div>
<!--            <div class="item">-->
<!--              <svg-icon name="capitain"></svg-icon>-->
<!--              <p>{{participant?.original?.leader?.username|truncate:20}}</p>-->
<!--            </div>-->
          </div>
        </div>
      </div>
      <!--<i class="icon-attention" *ngIf="participant.incomplete"></i>-->

    </div>
  </div>
  </ng-container>
  <ng-template #nodata>
    <div class="no-data " *ngIf="participants?.length==0">
      <h2>No Winners Yet</h2>
    </div>
  </ng-template>

</div>
<ng-template #loading>
  <app-loading-indicator></app-loading-indicator>
</ng-template>
